import mdast from 'mdast';

import { SerializeOptions } from '@lumapps/wrex/serialization/markdown/toMarkdown/types';

import { QUOTE_BLOCK } from '../../constants';

export const QUOTE_ELEMENTS: SerializeOptions['elements'] = {
    [QUOTE_BLOCK]: (_, children) => ({ type: 'blockquote', children }) as mdast.Blockquote,
};
